import React from 'react';
import emailjs from 'emailjs-com';

export default function ContactFormValidation(initialFormValues, ContactUsFormValidationRules) {
  const [values, setValues] = React.useState(initialFormValues);
  const [errors, setErrors] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0;
      if (noErrors) {
        emailjs.send('gmail', 'XcE5KwPK1', values, 'user_Ythva3kfp2ah0b77g5bCJ').then(
          function (response) {
            alert('Our consultants will respond to you soon.');
          },
          function (error) {
            console.log('FAILED...', error);
          }
        );
        // setIsSubmitting(false);
      } else {
        setIsSubmitting(false);
      }
    }
  }, [isSubmitting]);

  function handleChange(event) {
    setValues({
      ...values,
      [event.target.name]: event.target.value, // use the bracket surrounding the event.target.name to dynamically change the property.
    });
  }

  function handleCheckBoxChange(event) {
    const val = event.target.checked ? event.target.value : '';
    setValues({
      ...values,
      [event.target.name]: val,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    setErrors(ContactUsFormValidationRules(values));
    setIsSubmitting(true);
    // Move to call useEffect
    // If there is error, no submit.
  }

  return { handleSubmit, handleChange, handleCheckBoxChange, values, errors, isSubmitting };
}
